<template>
    <component
        :is="componentName"
        ref="map"
        :center="center"
        :zoom="zoom"
        :address="address"
        :boundary="boundary"
        :markerData="markerData"
        :class="[
            'search-map',
            'template4',
            showMapSearch ? '' : 'hide-map-search'
        ]"
        :tools="isMobileSize ? MOBILE_MAPTOOL : PC_MAPTOOL"
        :markerEventMap="markerEventMap"
        @mapLoad="mapLoad"
        :mapConfig="mapConfig"
        @change="onMapChange"
    >
        <HouseList
            v-if="houseList"
            v-outsideclick="hideHouseList"
            v-outsidetouchstart="hideHouseList"
            :houses="houseList"
            :isInMap="true"
            class="house-list"
        />
    </component>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import Core from '../search-map';
import { defineAsyncComponent } from 'vue';
import { getAsyComponent } from '@/common/utils/load-module.js';

export default {
    data: function() {
        return {};
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page || {}
        }),
        MOBILE_MAPTOOL() {
            return [
                {
                    name: 'search',
                    text: this.$t('md-search-result.searchThisArea'),
                    css: 'left: calc(50% - 150px/2); bottom: 30px;'
                },
                {
                    name: 'draw',
                    tip: this.mapDrawTip,
                    css: 'right: 20px; top: 10px',
                    drawIcon: 'icon-map-edit',
                    clearIcon: 'icon-clear2',
                    changeStyle: true
                },
                {
                    name: 'school',
                    css: 'right: 126px; top: 10px',
                    icon: 'icon-map-school',
                    value: false,
                    changeStyle: true
                },
                {
                    name: 'maptype',
                    css: 'right: 15px;bottom: 143px'
                },
                {
                    name: 'nearby',
                    css: 'right: 15px;bottom: 85px'
                }
            ];
        },
        IS_GOOGLE({ page }) {
            return page.map?.type === 'google';
        },
        componentName({ IS_GOOGLE }) {
            return IS_GOOGLE ? 'Map' : 'hereMap';
        },
        PC_MAPTOOL({ IS_GOOGLE, mapDrawTip, showSchool, mapSearchText }) {
            return [
                {
                    name: 'zoom',
                    css: 'right: 20px; bottom: 20px'
                },
                {
                    name: 'draw',
                    tip: mapDrawTip,
                    css: 'right: 20px; top: 10px',
                    drawIcon: 'icon-edit',
                    clearIcon: 'icon-clear2',
                    changeStyle: true
                },
                {
                    name: 'school',
                    css: 'right: 126px; top: 10px',
                    icon: 'icon-school2',
                    value: showSchool,
                    changeStyle: true
                },
                {
                    name: 'search',
                    text: mapSearchText,
                    css: 'left: 20px; top: 10px;',
                    changeStyle: true
                },
                {
                    name: 'maptype',
                    css: IS_GOOGLE
                        ? 'left: 0;bottom: 30px'
                        : 'left: 0;bottom: 0',
                    icon: 'icon-change'
                },
                {
                    name: 'nearby',
                    css: 'right: 20px;bottom: 85px'
                }
            ];
        }
    },
    components: {
        HouseList: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/list-v3_brief-list"*/ '@/modules/md-house/list-v3/brief-list/index.vue'
            )),
        Map: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map_fashion"*/ '@/components/map/fashion.vue'
            )),
        hereMap: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map-here_fashion"*/ '@/components/map-here/fashion.vue'
            ))
    },
    mixins: [Core]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '.././search-map.scss';
.search-map.template4 {
    .marker-house {
        .marker-pop {
            @media (max-width: 800px) {
                display: none !important;
            }
        }
    }
    &.hide-map-search {
        .map-tool.search {
            display: none;
        }
    }
    &.hide-school {
        .map-tool.school {
            display: none;
        }
    }
    .house-list {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        overflow: auto;
        max-height: 200px;
        padding: 0 15px;
        background-color: white;
        -webkit-overflow-scrolling: auto;
        .house-list-item {
            padding: 10px 0;
            border-bottom: 1px solid #f1f2f3;
            margin-bottom: 0;
            &:hover {
                background-color: white;
            }
            &:last-child {
                border-bottom: none;
            }
            .house-preview {
                min-height: 84px;
                width: 112px;
                margin: 0;
                .house-count {
                    display: none;
                }
                .checkbox {
                    display: none;
                }
            }
            .house-detail {
                border-bottom: none;
                padding: 0 0 0 10px;
                margin-left: 0;
                .icon-fav {
                    top: 0;
                }
                .house-price,
                .house-sold-price {
                    margin-top: 6px;
                    font-size: 12px;
                    line-height: 12px;
                    height: 12px;
                    @include color-theme();
                }
                .house-sold-price {
                    color: #515666;
                }
                .house-basic {
                    margin-top: 20px;
                    line-height: 14px;
                    font-size: 12px;
                    color: #8b93a7;
                }
                .house-address {
                    font-family: var(--font-normal);
                    font-size: 12px;
                    font-weight: 400;
                    margin: 2px 0 0 0;
                    line-height: 14px;
                    color: #000;
                    @include ellipsis();
                }
                .house-info,
                .house-trend,
                .house-initial-price {
                    display: none;
                }
            }
        }
    }
}
</style>
